import * as React from 'react';
import css from '../../RichTextEditor.scss';

export const Separator = () => <div className={ css.separator } />;
